const axios = require('axios');

const dev = 'http://localhost:5000'
const prod = 'https://playlister-backend.herokuapp.com'
let axiosConfig = {
  crossdomain:true
};

const fetch_endpoint = (data,endpoint) =>{
  return new Promise((resolve,reject)=>{
    axios.post(prod+endpoint,data,axiosConfig).then((result)=>{
      resolve(result.data)
    }).catch((err)=>{
      reject(err)
    })
  })
}

export default fetch_endpoint